import { getDeviceInfo } from "hub/src/utils/getDeviceInfo";
import { setupNativePlatformQueryClientProvider } from "./setupNativePlatformQueryClientProvider";
import { setupWebPlatformQueryClientProvider } from "./setupWebPlatformQueryClientProvider";

export const PlatformSpecificQueryClientProvider = getDeviceInfo().isNativeApp
  ? setupNativePlatformQueryClientProvider()
  : setupWebPlatformQueryClientProvider();
